import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import React from "react";

export default function TaskFieldDocumentViewer(props) {
  const { title, isPreview } = props;
  return isPreview ? (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h5" component="h5">
          {title}
        </Typography>
      </CardContent>
    </Card>
  ) : (
    ""
  );
}
